import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { getProfileOwner } from '../../selectors/users';
import { API_BASE_PATH } from '../../../server/routes/constants';
import { PapiActivityBadgesRequestParams } from '../../../types/papi';

function fetchFromApi(params) {
  return axios
    .get(`${API_BASE_PATH}/module/badge_activity`, { params })
    .catch(response => false);
}

export default function* fetchMoreBadgeActivity(action) {
  const { streamId } = action;

  const [offset, limit, moduleId, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state =>
      streamSelectors.getStreamParam(state, streamId, 'moduleId')
    ),
    select(getProfileOwner),
  ]);

  const queryParams: PapiActivityBadgesRequestParams = {
    username: profileOwner.user.username,
    moduleid: moduleId,
    offset,
    limit,
  };

  const response = yield call(fetchFromApi, queryParams);

  if (response && response.status === 200) {
    const { hasMore, nextOffset, results } = response.data;

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: results,
      })
    );
  }

  // TODO error catching
}
